import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import type { App } from 'vue';
import VueVirtualScroller from 'vue-virtual-scroller';

export function setupVirtualScroller(app: App) {
  app.use(VueVirtualScroller);
}
